module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("意见反馈列表")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "formInline",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.formInline.phone),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "phone", $$v)
      },
      expression: "formInline.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('formInline')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.fetchList,
      "element-loading-text": "拼命加载中",
      "default-sort": {
        prop: 'status'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userManage.nickName",
      "label": "用户昵称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "反馈类型"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.type === 0) ? _c('span', [_vm._v("产品建议")]) : _vm._e(), _vm._v(" "), (_vm.row.type === 1) ? _c('span', [_vm._v("程序错误")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "created",
      "label": "提交时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "状态",
      "sortable": "",
      "prop": "status"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.status === 0 || _vm.row.status === null) ? _c('span', [_vm._v("未处理")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 1) ? _c('span', [_vm._v("已处理")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "200",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [(_vm.row.status === 0 || _vm.row.status === null) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleCheck(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("标记已反馈")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 1) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            }
          }, [_vm._v("已反馈")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleView(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("查看")]), _vm._v(" "), (_vm.Role === '1') ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDelete(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 20,
      "layout": "total, prev, pager, next",
      "total": _vm.totalNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看反馈详情",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户昵称：",
      "label-width": "150px"
    }
  }, [(_vm.form.userManage) ? _c('span', [_vm._v(_vm._s(_vm.form.userManage.nickName))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "反馈类型：",
      "label-width": "150px"
    }
  }, [(_vm.form.type === 0) ? _c('span', [_vm._v("产品建议")]) : _vm._e(), _vm._v(" "), (_vm.form.type === 1) ? _c('span', [_vm._v("程序错误")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系方式：",
      "label-width": "150px"
    }
  }, [(_vm.form.userManage) ? _c('span', [_vm._v(_vm._s(_vm.form.userManage.username))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "反馈内容：",
      "label-width": "150px"
    }
  }, [(_vm.form.content) ? _c('span', [_vm._v(_vm._s(_vm.form.content))]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ba85428"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/FeedBack.vue
// module id = 739
// module chunks = 1